import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import "@/index.css";
import App from "@/App";

const container = document.getElementById("root");
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Only hydrate real prerendered snapshots (marked by scripts/prerender.js).
// Otherwise createRoot() wipes the static SEO fallback and renders fresh.
const isPrerendered = document.documentElement.getAttribute("data-prerendered") === "true";
if (isPrerendered) {
  hydrateRoot(container, app);
} else {
  createRoot(container).render(app);
}
